import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Checkbox from "../../common/checkbox/checkbox.component.jsx";
import TaxSelect from "../../common/pricing/taxselect.component.jsx";
import DefaultDiscount from "../../customer/defaultDiscount.component.jsx";
import RecurringStatementOptions from "../../customer/recurringstatement.component.jsx";
import PaymentTermSelect from "../../payment-term/locationselect.component.jsx";

const COMPANIES_OBJECT = "companies"
class BulkContactsUpdatesForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            taxId: '',
            paymentTermId: '',
            language: '',
            defaultDiscount: {
                discountValue: 0,
                discountType: 'percent-before-taxes',
                enabled: false,
            },
            recurringStatement: {
                attributes: {
                    dayOfMonth: 1,
                    capturePayment: false,
                    sendEmail: false,
                    enabled: false,
                }
            },
            actives: [],
            onClose: this.props.onClose || function () { },
            onChange: this.props.onChange || function () { },
        }
        this.onChange = this.onChange.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        }, this.onChange)
    }

    onChange() {
        let updates = {}
        const fields = this.state.actives
        for (let i in fields) {
            const field = fields[i]
            if (field === 'recurringStatement') {
                updates[field] = this.state[field].attributes
            } else {
                updates[field] = this.state[field]
            }
        }
        this.state.onChange({
            updates: updates,
        })
    }

    isActive(field) {
        return this.state.actives.filter(f => field === f).length > 0
    }

    selectField(field, isChecked) {
        let actives = this.state.actives
        if (isChecked) {
            actives.push(field)
            actives.filter((value, index, self) => {
                return self.indexOf(value) === index;
            })
        } else {
            actives = this.state.actives.filter(f => field !== f)
        }
        this.setState({
            actives: actives,
        })

        this.onChange()
    }

    render() {
        const messages = defineMessages({
            "user.form.edit.language_choose": {
                id: 'user.form.edit.language_choose',
                defaultMessage: 'Choose language',
            },
            "user.form.edit.language_english_us": {
                id: 'user.form.edit.language_english_us',
                defaultMessage: 'English US',
            },
            "user.form.edit.language_english_ca": {
                id: 'user.form.edit.language_english_ca',
                defaultMessage: 'English Canada',
            },
            "user.form.edit.language_french_ca": {
                id: 'user.form.edit.language_french_ca',
                defaultMessage: 'French Canada',
            },
        })

        return <div>
            <div className={"row py-2 " + (!this.isActive('paymentTermId') ? 'bg-light' : '')}>
                <label className="col-4 col-form-label text-align-right" htmlFor={'paymentTermId'}>
                    <FormattedMessage
                        id="customer.modal.add_form.default_payment_term_label"
                        defaultMessage="Payment term"
                    />
                </label>
                <div className="col-6">
                    {this.isActive('paymentTermId') ? <PaymentTermSelect
                        value={this.state.paymentTermId}
                        onChange={paymentTermId => {
                            this.setState({
                                paymentTermId: paymentTermId,
                            }, this.onChange)
                        }}
                        className="form-control"
                    /> : null}
                </div>
                <div className="col-2 text-center">
                    <Checkbox id={'paymentTermId'} checked={this.isActive('paymentTermId')} onChange={isChecked => {
                        this.selectField('paymentTermId', isChecked)
                    }} />
                </div>
            </div>
            {this.props.object != COMPANIES_OBJECT &&
                <div className={"row py-2 " + (!this.isActive('language') ? 'bg-light' : '')}>
                    <label className="col-4 col-form-label text-align-right" htmlFor={'language'}>
                        <FormattedMessage
                            id="customer.modal.add_form.contact_language_label"
                            defaultMessage="Contact Language"
                        />
                    </label>
                    <div className="col-6">
                        {this.isActive('language') ? <select value={this.state.language} className="custom-select mr-1" id="dropDownLanguage" name="language" onChange={this.handleFormChange}>
                            <option value="">
                                {this.props.intl.formatMessage(messages['user.form.edit.language_choose'])}
                            </option>
                            <option value="en-US">
                                {this.props.intl.formatMessage(messages['user.form.edit.language_english_us'])}
                            </option>
                            <option value="en-CA">
                                {this.props.intl.formatMessage(messages['user.form.edit.language_english_ca'])}
                            </option>
                            <option value="fr-CA">
                                {this.props.intl.formatMessage(messages['user.form.edit.language_french_ca'])}
                            </option>
                        </select> : null}
                    </div>
                    <div className="col-2 text-center">
                        <Checkbox id={'language'} checked={this.isActive('language')} onChange={isChecked => {
                            this.selectField('language', isChecked)
                        }} />
                    </div>
                </div>
            }
            <div className={"row py-2 " + (!this.isActive('taxId') ? 'bg-light' : '')}>
                <label className="col-4 col-form-label text-align-right" htmlFor={'taxId'}>
                    <FormattedMessage
                        id="customer.modal.add_form.default_tax_label"
                        defaultMessage="Default tax"
                    />
                </label>
                <div className="col-6">
                    {this.isActive('taxId') ? <TaxSelect
                        value={this.state.taxId}
                        onChange={taxId => { this.setState({ taxId: taxId }, this.onChange) }}
                        className="form-control"
                    /> : ''}
                </div>
                <div className="col-2 text-center">
                    <Checkbox id={'taxId'} checked={this.isActive('taxId')} onChange={isChecked => {
                        this.selectField('taxId', isChecked)
                    }} />
                </div>
            </div>
            <div className={"row py-2 " + (!this.isActive('recurringStatement') ? 'bg-light' : '')}>
                <label className="col-4 col-form-label text-align-right" htmlFor="recurringStatement">
                    <FormattedMessage
                        id="customer.view.account_statement_automation_label"
                        defaultMessage="Account statement automation"
                    />
                </label>
                <div className="col-6 d-flex align-items-center">
                    {this.isActive('recurringStatement') ? <RecurringStatementOptions
                        editable={true}
                        noSave={true}
                        value={this.state.recurringStatement}
                        onChange={info => { this.setState({ recurringStatement: info }, this.onChange) }}
                    /> : ''}
                </div>
                <div className="col-2 text-center">
                    <Checkbox id={'recurringStatement'} checked={this.isActive('recurringStatement')} onChange={isChecked => {
                        this.selectField('recurringStatement', isChecked)
                    }} />
                </div>
            </div>
            <div className={"row py-2 " + (!this.isActive('defaultDiscount') ? 'bg-light' : '')}>
                <label className="col-4 col-form-label text-align-right" htmlFor="defaultDiscount">
                    <FormattedMessage
                        id="customer.view.default_discount_label"
                        defaultMessage="Default discount"
                    />
                </label>
                <div className="col-6 d-flex align-items-center">
                    {this.isActive('defaultDiscount') ? <DefaultDiscount
                        discountType={this.state.defaultDiscount.discountType}
                        discountValue={this.state.defaultDiscount.discountValue}
                        currency={AppContext.getCurrency()}
                        editable={true}
                        noSave={true}
                        enabled={this.state.defaultDiscount.enabled}
                        onChange={discount => { this.setState({ defaultDiscount: discount }, this.onChange) }}
                    /> : ''}
                </div>
                <div className="col-2 text-center">
                    <Checkbox id={'defaultDiscount'} checked={this.isActive('defaultDiscount')} onChange={isChecked => {
                        this.selectField('defaultDiscount', isChecked)
                    }} />
                </div>
            </div>
        </div>
    }
}

export default injectIntl(BulkContactsUpdatesForm)





// WEBPACK FOOTER //
// ./src/bulk/operations/contacts-updates.component.jsx